import { CustomStylesSection } from './sections/CustomStyles'
import Appearance from './sections/Appearance'

type Props = {
  workspaceId: string
  botId: string
}

export function AppearanceConfig({ workspaceId, botId }: Props) {
  return (
    <div className="flex flex-col gap-6">
      <Appearance workspaceId={workspaceId} botId={botId} />
      <CustomStylesSection workspaceId={workspaceId} botId={botId} />
    </div>
  )
}
